import * as React from "react"

function Spyhole(props) {
  return (
    <svg
      width={22}
      height={25}
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.684 2.392a96.534 96.534 0 00-4.371 1.286.728.728 0 00-.506.587C.952 10.517 2.925 15.08 5.28 18.084c1.18 1.508 2.459 2.624 3.524 3.357a9.657 9.657 0 001.375.802c.186.085.337.143.452.177.051.016.103.03.156.038.011-.001.06-.008.155-.037.116-.035.267-.093.453-.178a9.66 9.66 0 001.375-.802 16.36 16.36 0 003.524-3.357c2.353-3.005 4.326-7.567 3.471-13.819a.728.728 0 00-.505-.587 95.085 95.085 0 00-4.371-1.286c-1.71-.451-3.284-.788-4.102-.788-.818 0-2.39.337-4.102.788zm-.41-1.55C7.946.4 9.721 0 10.785 0c1.062 0 2.84.4 4.512.842 1.493.4 2.975.837 4.447 1.308.847.27 1.486.999 1.61 1.899.918 6.733-1.214 11.722-3.798 15.023a17.953 17.953 0 01-3.879 3.69c-.511.358-1.051.672-1.615.94-.433.198-.895.36-1.277.36-.382 0-.844-.162-1.277-.36a11.08 11.08 0 01-1.615-.94 17.953 17.953 0 01-3.878-3.69C1.43 15.77-.702 10.782.218 4.049a2.332 2.332 0 011.609-1.9A98.036 98.036 0 016.273.843z"
        fill="#1F1F43"
      />
      <path
        d="M13.191 9.625a2.406 2.406 0 11-4.812 0 2.406 2.406 0 014.812 0z"
        fill="#1F1F43"
      />
      <path
        d="M9.84 12.087a.802.802 0 01.79-.669h.251a.802.802 0 01.79.664l.556 3.208a.803.803 0 01-.79.939h-1.34a.803.803 0 01-.791-.934l.534-3.208z"
        fill="#1F1F43"
      />
    </svg>
  )
}

export default Spyhole
